import { render } from "./FormRecrutamento.vue?vue&type=template&id=6605da49"
import script from "./FormRecrutamento.vue?vue&type=script&lang=js"
export * from "./FormRecrutamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__